'use client';

import type { ReactNode } from 'react';
import { useCollapseEqualHeight } from '@/components/FleetCategory/FleetCategoryComparisonCard/useCollapseEqualHeight';
import { Carousel } from '@/components/carousel/Carousel';
import { breakpointUtils } from '@/lib/breakpoints';
export type ComparisonCarouselProps = {
  children?: ReactNode;
};
export function ComparisonCarousel({
  children
}: ComparisonCarouselProps) {
  const ref = useCollapseEqualHeight();
  return <Carousel ref={ref} className="[--carousel-spacing:24px] md:[--carousel-spacing:40px]" options={{
    active: true,
    align: 'center',
    breakpoints: {
      [breakpointUtils.up('md')]: {
        active: false,
        slidesToScroll: 3
      }
    },
    containScroll: 'keepSnaps',
    loop: false,
    skipSnaps: false,
    slidesToScroll: 1,
    startIndex: 0
  }} hideOverflow={false}>
            {children}
        </Carousel>;
}